export default "__VITE_ASSET__DfdC_rVj__"